import { client } from 'repositories/client';
import { paths } from 'repositories/migration/paths';
import { SessionResponse } from 'repositories/migration/responseType';

const session = async (token: string): Promise<SessionResponse> => {
  const params = new FormData();
  params.append('onetime_token', token);

  const response = await client.post<SessionResponse>(paths.session, params);

  return response.data;
};

export const migration = {
  session,
};
